<template>
<div class="flex flex-col items-center justify-center min-h-36 md:min-h-96 md:w-5/6 mx-auto md:pl-9 p-5">
    <ProductDetail @add-product-to-cart="$emit('add-product-to-cart', $event)" :product="getProduct(id)" />
</div>
</template>

<script>
import FootPrintsLoading from './FootPrintsLoading';
import ProductDetail from './ProductDetail';

export default {
    name: "Product",
    props: ['id'],
    components: {
        FootPrintsLoading,
        ProductDetail
    },
    computed: {
        products() {
            return [...this.$store.getters['app/products']] || [];
        },
        categories() {
            return [...this.$store.getters['app/categories']] || [];
        }
    },
    methods: {
        getProduct(id) {
            return this.products.find(item => item.id === id);
        }
    }
}
</script>
